'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton from "./io.intela.sites.digitalinternship.ui.-Button.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$1() {
  this.fF = null;
  $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton.$ct_Lio_intela_sites_digitalinternship_ui_Button__T__(this, "btn btn-primary btn-lg");
}
export { $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$1 as $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$1 };
$p = $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$1.prototype = new $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton.$h_Lio_intela_sites_digitalinternship_ui_Button();
$p.constructor = $c_Lio_intela_sites_digitalinternship_ui_Button$$anon$1;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_ui_Button$$anon$1() {
}
export { $h_Lio_intela_sites_digitalinternship_ui_Button$$anon$1 as $h_Lio_intela_sites_digitalinternship_ui_Button$$anon$1 };
$h_Lio_intela_sites_digitalinternship_ui_Button$$anon$1.prototype = $p;
$p.G = (function() {
  return 0;
});
$p.H = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.I = (function() {
  return "Primary";
});
$p.t = (function() {
  return "Primary";
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Primary");
});
var $d_Lio_intela_sites_digitalinternship_ui_Button$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_ui_Button$$anon$1, "io.intela.sites.digitalinternship.ui.Button$$anon$1", ({
  fz: 1,
  bU: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1,
  V: 1,
  y: 1,
  N: 1,
  S: 1
}));
export { $d_Lio_intela_sites_digitalinternship_ui_Button$$anon$1 as $d_Lio_intela_sites_digitalinternship_ui_Button$$anon$1 };
//# sourceMappingURL=io.intela.sites.digitalinternship.ui.-Button$$anon$1.js.map
